import MapboxDraw from '@mapbox/mapbox-gl-draw';

// Draw modes only see the public mode interface; the store that remembers the
// map's initial dragPan setting hangs off the private context.
export interface ModeContext extends MapboxDraw.DrawCustomModeThis {
  _ctx?: {
    store?: { getInitialConfigValue?: (interaction: string) => boolean };
  };
}

// Deferred a tick, as the original plugin did: mapbox-gl-draw toggles dragPan
// itself while a drag is in flight, and this has to win.
export const enable = (ctx: ModeContext) => {
  setTimeout(() => {
    const store = ctx._ctx?.store;
    // Called on the store: the method reads the map's initial config off
    // `this`, so a detached reference would throw here.
    if (!ctx.map?.dragPan || !store?.getInitialConfigValue) return;
    if (!store.getInitialConfigValue('dragPan')) return;
    ctx.map.dragPan.enable();
  }, 0);
};

export const disable = (ctx: ModeContext) => {
  setTimeout(() => {
    if (!ctx.map?.dragPan) return;
    ctx.map.dragPan.disable();
  }, 0);
};
